// src/pages/vendas/ModalPedidosAnotaAI.js
import React, { useEffect, useState } from 'react';
import Select from '../../components/input/Select';
import { fetchData } from '../../services/Api';
import { usePDV } from '../../contexts/vendas/PDVContext';
import { useCaixa } from '../../contexts/caixas/CaixaContext';
import { useProduto } from '../../contexts/produtos/ProdutoContext';
import { useMessage } from '../../contexts/geral/MessageContext';
import { NotaItem } from '../../models/vendas/NotaItem';
import { useAlert } from '../../contexts/geral/AlertContext';
import ModalPortal from '../../components/modalForm/ModalPortal.js';

const ModalPedidosAnotaAI = ({ show, onClose }) => {
  const [statusPedido, setStatusPedido] = useState(2);
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [showItensModal, setShowItensModal] = useState(false);
  const [pedidosSelecionados, setPedidosSelecionados] = useState([]);
  const { itensPDV, setItensPDV, setItemPDVSel } = usePDV();
  const {caixaSel } = useCaixa();
  const {produtos} = useProduto();

  const { showMessage } = useMessage();
  const { showAlert } = useAlert();
  

  useEffect(() => {
    if (show) {
      setPedidosSelecionados([]); // desmarca todos
      carregarPedidos();
    }
  }, [show, statusPedido]);

  const carregarPedidos = async () => {
    try {
      setLoading(true);
      const response = await fetchData(`/AnotaAi/BuscaPedidos?status=${statusPedido}`);
      setPedidos(response || []);
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleSelecionado = (pedidoId) => {
    setPedidosSelecionados(prev =>
      prev.includes(pedidoId)
        ? prev.filter(id => id !== pedidoId)
        : [...prev, pedidoId]
    );
  };

   const handleConfirm = () => {

    if (!caixaSel?.aberto) {
            showMessage("Caixa fechado! Não é possível adicionar produtos. Pressione 'Alt+C' ou clique no botão do caixa para realizar a abertura.", 'warning');
            return;
        }

    let novosItens = [];
    let numItem = itensPDV.length + 1;    

    pedidos
        .filter(p => pedidosSelecionados.includes(p.idAnotaAi))
        .forEach(pedido => {
            if (pedido.itens && pedido.itens.length > 0) {
                pedido.itens.forEach(itemPedido => {
                    const produto = produtos.find(prod => prod.id === itemPedido.produto.id);
                    if (produto) {
                        const newItemPDV = new NotaItem();
                        newItemPDV.produtoId = produto.id;
                        newItemPDV.item = numItem++;
                        newItemPDV.cfop = produto.cfop;
                        newItemPDV.unCom = produto.unTrib;
                        newItemPDV.qtdCom = itemPedido.qtdCom;                        
                        newItemPDV.vUnCom = (itemPedido.vProd/itemPedido.qtdCom) ?? itemPedido.vUnCom;
                        newItemPDV.vProd = itemPedido.vProd;
                        newItemPDV.xProd = produto.descricao;
                        newItemPDV.produto = produto;
                        newItemPDV.idAnotaAi = pedido.idAnotaAi;
                        novosItens.push(newItemPDV);
                    } else {
                        console.warn(`Produto ID ${itemPedido.produtoId} não encontrado.`);
                    }
                });
                //Adiciona os fretes
                if (pedido.valorFrete>0) {
                  const produto = produtos.find(prod => prod.id === 999);
                  if (produto) {
                      const newItemPDV = new NotaItem();
                      newItemPDV.produtoId = produto.id;
                      newItemPDV.item = numItem++;
                      newItemPDV.cfop = produto.cfop;
                      newItemPDV.unCom = produto.unTrib;
                      newItemPDV.qtdCom = 1;                        
                      newItemPDV.vUnCom = pedido.valorFrete;
                      newItemPDV.vProd = pedido.valorFrete;
                      newItemPDV.xProd = produto.descricao;
                      newItemPDV.produto = produto;
                      novosItens.push(newItemPDV);
                  } else {
                      console.warn(`Produto ID 999 não encontrado.`);
                  }
                }
            }
        });

    if (novosItens.length > 0) {
        setItensPDV(prev => [...prev, ...novosItens]);
        setItemPDVSel(novosItens[novosItens.length-1]);
        showAlert(`${novosItens.length} itens adicionados ao PDV`, 'success');
    } else {
        showMessage("Nenhum item foi adicionado. Verifique se os produtos existem no cadastro.", 'warning');
    }

    onClose();
  };

  if (!show) return null;

  return (
    <>
      {/* Modal principal */}
      <ModalPortal show={show}>
      <div
        className="modal d-block"
        tabIndex="-1"
        role="dialog"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100dvh',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          className="modal-dialog"
          role="document"
          style={{
            maxWidth: '800px',
            width: '100%',
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Pedidos do Anota Aí</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>
            <div className="modal-body">
              <Select 
                label="Status do Pedido"
                value={statusPedido}
                size={170}
                onChange={(e) => setStatusPedido(parseInt(e.target.value))}
                options={[
                  { value: 1, label: 'Em Produção' },
                  { value: 2, label: 'Pronto' },
                  { value: 3, label: 'Finalizado' }
                ]}
                style={{ marginBottom: '10px' }}
              />

              {loading ? (
                <p>Carregando pedidos...</p>
              ) : pedidos.length === 0 ? (
                <p>Nenhum pedido encontrado.</p>
              ) : (
                <table className="table table-striped table-sm">
                  <thead>
                    <tr>                      
                      <th>Cliente</th>
                      <th>Tipo</th>
                      <th>Origem</th>
                      <th>Valor Total</th>
                      <th>Ações</th>
                      <th>Sel</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pedidos.map((pedido) => (
                      <tr key={pedido.idAnotaAi}>
                        
                        <td>{pedido.cliente}</td>
                        <td>{pedido.tipo==="TAKE" ? 'Retirada' : pedido.tipo}</td>
                        <td>{pedido.origem}</td>
                        <td>R$ {pedido.valorTotal.toFixed(2)}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-info"
                            onClick={() => {
                              setPedidoSelecionado(pedido);
                              setShowItensModal(true);
                            }}
                          >
                            Ver Itens
                          </button>
                        </td>
                        <td>
                          <input
                            type="checkbox"                            
                            checked={pedidosSelecionados.includes(pedido.idAnotaAi)}
                            onChange={() => toggleSelecionado(pedido.idAnotaAi)}
                            disabled={pedido.origem?.toLowerCase().includes('ifood')}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Cancelar
              </button>
              <button className="btn btn-primary" onClick={handleConfirm}>
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
      </ModalPortal>

      {/* Modal de Itens */}
      {showItensModal && pedidoSelecionado && (
      <ModalPortal show={showItensModal}>
        <div
          className="modal d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100dvh',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="modal-dialog" role="document" style={{ maxWidth: '600px', width: '100%' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Itens do Pedido</h5>
              </div>
              <div className="modal-body">
                {pedidoSelecionado.itens && pedidoSelecionado.itens.length > 0 ? (
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Qtd</th>
                        <th>Preço</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pedidoSelecionado.itens.map((item, index) => (
                        <tr key={index}>
                          <td>{item.produto?.descricao ?? 'Produto não encontrado'}</td>
                          <td>{item.qtdCom}</td>
                          <td>R$ {item.vProd.toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>Nenhum item encontrado.</p>
                )}
              </div>
              <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
                <strong>Total: R$ {pedidoSelecionado.valorTotal.toFixed(2)}</strong>
                <button className="btn btn-secondary" onClick={() => setShowItensModal(false)}>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalPortal>
      )}
    </>
  );
};

export default ModalPedidosAnotaAI;
